// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.udrO2{display:flex;flex-direction:column;gap:8px;align-items:start;margin-bottom:24px;width:700px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `udrO2`
};
export default ___CSS_LOADER_EXPORT___;
